import {AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, Subscription, fromEvent } from 'rxjs';
import {debounce, debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-inline-edit',
  templateUrl: './inline-edit.component.html',
  styleUrls: ['./inline-edit.component.scss']
})
export class InlineEditComponent implements OnInit {
  @Input()
  public rowData: any;

  @Input()
  public value: any;

  @Input()
  public key = '';

  @Output() valueEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {}

  changeValue(e: any) {
    this.valueEmitter.emit(e.target.value);
  }
}
